import { Alert, AlertDescription, AlertIcon, type AlertProps } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { BidDto } from "../../../../autogen/bff-api";
import { isBidEditable } from "./publicBidEditability";

export const RoundBidDocumentsNotice = ({ bid, ...alertProps }: { bid: BidDto | undefined } & AlertProps) => {
  const { t } = useTranslation();
  if (!bid?.forNegotiationRound || !isBidEditable(bid)) return null;
  return (
    <Alert status="info" rounded="md" fontSize="sm" {...alertProps}>
      <AlertIcon />
      <AlertDescription>
        {t("Documents don't carry over from your previous bid. Upload again the ones that still apply.")}
      </AlertDescription>
    </Alert>
  );
};
